// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import { RowCreate } from '@Organisms/Dashboard/DashboardRowCreate/DashboardRowCreate';
import NewBarDrawer from '@Organisms/Dashboard/WidgetManage/Bar/NewBarDrawer';
import NewDonutDrawer from '@Organisms/Dashboard/WidgetManage/Donut/NewDonutDrawer';
import NewLineDrawer from '@Organisms/Dashboard/WidgetManage/Line/NewLineDrawer';
import NewTextDrawer from '@Organisms/Dashboard/WidgetManage/Text/NewTextDrawer';
import NewCounterDrawer from '@Organisms/Dashboard/WidgetManage/Counter/NewCounterDrawer';
import NewRadarDrawer from '@Organisms/Dashboard/WidgetManage/Radar/NewRadarDrawer';
import NewGaugeDrawer from '../WidgetManage/Gauge/NewGaugeDrawer';

import './DashboardConfig.scss';

const DashboardConfig = (): ReactElement => (
    <div className="dashboard-config">
        <div className="config-buttons">
            <RowCreate />
            <NewBarDrawer />
            <NewDonutDrawer />
            <NewLineDrawer />
            <NewRadarDrawer />
            <NewCounterDrawer />
            <NewTextDrawer />
            <NewGaugeDrawer />
        </div>
    </div>
);

export default DashboardConfig;
